{
  "decrease": "Reducer {fieldLabel}",
  "increase": "Øg {fieldLabel}",
  "numberField": "Talfelt"
}
